import React, { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Favicon from "react-favicon";
import Router from './routes/routes';
import { ApiCalls } from './services/axios/apiCalls';
import { parseCustomQueryString } from './common/utils/urlUtils'
import defaultDomain from './utils/defaultDomain.json'

const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none'
    }
  }
});
function App() {
  /** COOKIES */
  const [cookies, setCookie, removeCookie] = useCookies(['login-kiwox-cookies']);

  /** SYSTEM DATA */
  const [systemData, setSystemData] = useState(defaultDomain);
  const [faviconUrl, setFaviconUrl] = useState(defaultDomain.favicon);

  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);

  const validateData = (data) => {
    let errors = [];

    if (!data.domain) {
      errors.push('El dominio es obligatorio.');
    }

    return errors;
  };

  useEffect(() => {
    async function fetchData() {
      let domain = '';

      /*const urlParams = new URLSearchParams(window.location.search);
      
      const siteParam = urlParams.get('site');*/

      const urlParams = window.location.search;
      const searchParams = parseCustomQueryString(urlParams)
      const siteParam = searchParams ? searchParams[0] : '';

      if (siteParam) {
        removeCookie('login-kiwox-cookies-token')
        removeCookie('login-kiwox-cookies-redirect')
        domain = siteParam;

      } else if (cookies['login-kiwox-cookies-login']) {
        domain = cookies['login-kiwox-cookies-login'].plattform;
      } else {
        domain = process.env.NODE_ENV === 'development' ? window.location.href : window.location.origin
        const cookieLogin = { channel: 'WEB', plattform: domain }
        //setCookie('login-kiwox-cookies-login', JSON.stringify(cookieLogin), { path: '/' })
      }

      const apiConfig = {
        method: "POST",
        baseURL: `${process.env.REACT_APP_API_URL}`,
        url: "/domain/get",
        mode: "cors",
        data: {
          domain
        },
      };
      try {
        const responseData = await ApiCalls(apiConfig);

        if (responseData.status === 200) {
          setSystemData({
            ...responseData.data,
            uuid: searchParams.uuid,
            totem: searchParams.totem,
          });

          // Añade el custom css indicado por la data
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = responseData.data.custom_css;
          document.head.appendChild(link);

          // Cambia el titulo del header
          document.title = responseData.data.name

          // Cambia el favicon
          setFaviconUrl(responseData.data.favicon ? responseData.data.favicon : defaultDomain.favicon);
        } else {
          setSystemData({
            ...defaultDomain,
            uuid: searchParams.uuid,
            totem: searchParams.totem,
          });

          // Añade el custom css indicado por la data
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = defaultDomain.custom_css;
          document.head.appendChild(link);
        }
      } catch (error) {
        setSystemData({
          ...defaultDomain,
          uuid: searchParams.uuid,
          totem: searchParams.totem,
        });

        // Añade el custom css indicado por la data
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = defaultDomain.custom_css;
        document.head.appendChild(link);
      }
    }

    fetchData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Favicon url={faviconUrl} />
      <CssBaseline />
      <Router systemData={systemData} />
    </ThemeProvider>
  );
}

export default App;
